import { SupportIframe } from "components/organisms/SupportIFrame";

const Support = () => {
  return <SupportIframe />;
};

export { Support };
